export default __webpack_public_path__ + "static/media/scroll-arrow-up.58b26e89.svg";